import React, { createContext, useContext, useState, useEffect } from 'react';
import Localization from '../services/Localization';
import * as Components from '../resources/Components';
import storefrontService from '../services/Storefront';
import { useStorefrontSettings } from './StorefrontSettingsContext';

const PIMProductConfigContext = createContext();
function PIMProductConfigProvider({ children, ...props }) {
    const [pIMProductConfigLoaded, setPIMProductConfigLoaded] = useState(false);
    const [settings, setSettings] = useState(props.settings || []);
    const [childComponents, setChildComponents] = useState(props.childComponents || {});
    const [labels, setLabels] = useState({});
    const { locale } = useStorefrontSettings();
    const storefrontNumber = ('00000' + props.storefrontNumber).slice(-5);

    useEffect(() => {
        getPIMProductConfigSettings();
    }, []);

    useEffect(() => {
        Localization.getComponentLabels(Components.PIMPRODUCT, locale, storefrontNumber)
            .then(res => setLabels(res))
    }, [locale]);

    const getPIMProductConfigSettings = () => {
        try {
            storefrontService.getPIMProductSettings(storefrontNumber).then((res) => {
                setSettings(res.settings || []);
                setChildComponents(res.childComponents || []);
                setPIMProductConfigLoaded(true);
            });
        } catch (error) {
            console.error("Error fetching PIMProduct settings:", error);
        }
    }
    return (
        <PIMProductConfigContext.Provider value={{ settings, childComponents, pIMProductConfigLoaded,labels}}>
            {children}
        </PIMProductConfigContext.Provider >
    );
}
function usePIMProductConfig() {
    const context = useContext(PIMProductConfigContext);
    if (context === undefined) {
        throw new Error('usePIMProductConfig must be used within a PIMProductConfigProvider');
    }
    return context;
}
function withPIMProductConfig(Component) {
    return function WrappedComponent(props) {
        const pIMProductConfig = usePIMProductConfig();
        return <Component {...props} PIMProductConfig={pIMProductConfig} />;
    };
}
export { PIMProductConfigProvider, usePIMProductConfig, withPIMProductConfig };